<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div id="pdfDialog"
  aria-label="DashGIS Print" fxFlex="1 1 auto"
  fxLayout="column" fxLayoutAlign="space-between stretch">
  <mat-dialog-content fxLayout="column" fxFlex>
    @if (isIOS) {
      <div>PDF display is not supported on iOS. Click Download to save the map.</div>
    }
    @if (!isIOS) {
      <object #objectElement
        [data]="blobUri"
        type="application/pdf"
        fxFlex="1 0 auto"
        fxLayoutAlign="center center">
        <div>PDF display is not supported on your browser with current settings. Click Download to save the map.</div>
      </object>
    }
  </mat-dialog-content>
  <mat-dialog-actions fxFlex="60px" fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="close()">Close</button>
    <button mat-button (click)="doDownload()">Download</button>
  </mat-dialog-actions>
</div>
